import React, { useContext, useState } from 'react';
import { Grid } from 'react-feather';
import { Link } from 'react-router-dom';
import { Image } from '../../AbstractElements';
import CustomizerContext from '../../_helper/Customizer';
import { megaLogo } from '../../api';

const SidebarLogo = () => {
  const { mixLayout, toggleSidebar } = useContext(CustomizerContext);
  const [toggle, setToggle] = useState(false);

  const openCloseSidebar = () => {
    toggleSidebar(!toggle);
    setToggle(!toggle);
  };

  return (

    <div className="logo-wrapper">
      { mixLayout ?
        <Link to={`${process.env.PUBLIC_URL}/${localStorage.getItem('homePage')}`}>
          <Image attrImage={{ className: 'img-fluid d-inline logo-size', src: megaLogo, alt: '' }} />
        </Link>
        :
        <Link to={`${process.env.PUBLIC_URL}/${localStorage.getItem('homePage')}`}>
          <Image attrImage={{ className: 'img-fluid d-inline logo-size', src: megaLogo, alt: '' }} />
        </Link>
      }
      <div className='back-btn' onClick={() => openCloseSidebar()}>
        <i className='fa fa-angle-left'></i>
      </div>
      <div className="toggle-sidebar" onClick={()=>openCloseSidebar()}>
        <Grid className="status_toggle middle sidebar-toggle" />
      </div>
    </div >
  );
};

export default SidebarLogo;